import React from 'react'
import Footer from '../Footer'
import EduThree from '../EduThree'

function ImgthsOne() {
    window.scrollTo(0,0);
    return (
        <div>
            <EduThree/>
            <Footer/>
        </div>
    )
}

export default ImgthsOne
